import "./style/Line.css"
function Line() {
    return (
        <div className="line">&nbsp;</div>
    );
}
export default Line;